module.exports = __webpack_public_path__ + "static/media/twitter.15856fc6.png";